import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable ,  of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';
import { TenantService } from 'app/core/services/tenant/tenant.service';

import { Page } from 'app/shared/models/page.model';

@Injectable()
export class PageService extends BaseAuthService {
  private cache: Page[] = [];

  constructor(protected http: HttpClient, protected authService: AuthService, private tenantService: TenantService) {
    super(http, authService);
  }

  getPage(slug, fresh = false): Observable<Page> {
    const cachedPage = this.cache.find(page => page.slug === slug);

    if (cachedPage && !fresh) {
      return of(cachedPage);
    }

    return this.get('page', { slug, newspaper: this.tenantService.newspaperSubname }).pipe(
      map(page => {
        const loadedPage = Page.fromObject(page[0]);
        this.cache.push(loadedPage);
        return loadedPage;
      })
    );
  }

  getUnSubscribeConfirmation(email: string, journal: string, codeClient: string, profileId : string): Observable<any> {
    return this.get('/unsubscribe_clubdeslecteurs', {email, journal, codeClient, profileId});
  }
}
